import { createStore, applyMiddleware, compose } from 'redux'
import { createResponsiveStoreEnhancer } from 'redux-responsive'
import thunk from 'redux-thunk'
import { analytics, createMKSUtils } from '../middleware/analytics'
import rootReducer from '../reducers'
import platform from '../../utils/platform'

/* In order to enable debugging on validation we
need to conditionally enable the redux devtools. */
/* eslint-disable */
const createComposer = () => {
  const slot = process.env.SLOT;
  // if (slot !== 'validation') {
  //   return compose;
  // }
  return (typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
  /* eslint-enable */
};

/**
 * Configure the Redux store for the app
 * @param preloadedState - the initial state of the App
 * @returns {Store<S>}
 */
const configureStore = (preloadedState) => {
  const composer = createComposer();
  const store = createStore(
    rootReducer,
    preloadedState,
    composer(
      createResponsiveStoreEnhancer({
        calculateStateInitially: false,
        performanceMode: true
      }),
      applyMiddleware(thunk, analytics)
    )
  );

  if (platform.isBrowser()) {
    // Add some utility functions for MKS peeeps.
    createMKSUtils(store);
  }

  return store;
};

export default configureStore



/** WEBPACK FOOTER **
 ** ./src/redux/store/configureStore.prod.js
 **/